import { useQuery } from "@tanstack/react-query";
import GKClientDataGrid from "components/GKClientDataGrid";
import axiosInstance from "utils/axiosInstance";

const PartnerTable = () => {
  const { data: advisorList, isFetching } = useQuery({
    queryKey: ["DASHBOARD_PARTNER_TABLE"],
    queryFn: () => axiosInstance.get(`/super_admin/partners/`, {}),
  });

  const columns = [
    {
      headerName: "Name",
      field: "name",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Phone Number",
      field: "phone",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Created on",
      field: "createdOn",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
  ];
  return (
    <GKClientDataGrid
      loading={isFetching}
      columns={columns}
      rows={advisorList?.data?.data || []}
    />
  );
};

export default PartnerTable;
